// extracted by mini-css-extract-plugin
export var chevron = "_4f-d";
export var disabled = "_4f-b";
export var error = "_4f-c";
export var hideBorder = "_4f-1";
export var icon = "_4f-e";
export var input = "_4f-0";
export var large = "_4f-f";
export var open = "_4f-9";
export var placeholder = "_4f-a";
export var regular = "_4f-5";
export var singleRowInput = "_4f-2";
export var singleSelectInput = "_4f-3 _4f-0";
export var small = "_4f-4";
export var spinnerContainer = "_4f-i";
export var tag = "_4f-7";
export var tagsContainer = "_4f-8";
export var tagsInput = "_4f-6 _4f-0";
export var xSmall = "_4f-g";
export var xxSmall = "_4f-h";